import { _getConsentState } from '../lib/withAnalytics';

const _getCookieValue = (cookieName) => {
  try {
    const consent = _getConsentState();
    if (!consent || !consent.marketing) {
      return null;
    }

    const value = '; ' + document.cookie;
    const parts = value.split(`; ${cookieName}=`);
    if (parts.length === 2)
      return (
        parts
          .pop()
          .split(';')
          .shift() || null
      );
    return null;
  } catch (error) {
    return null;
  }
};

export const getFbclid = () => {
  return _getCookieValue('paloma_fbc');
};

export const getFbp = () => {
  return _getCookieValue('_fbp');
};

export const getGa = () => {
  return _getCookieValue('_ga');
};

export const getGclAw = () => {
  return _getCookieValue('_gcl_aw');
};
